import setAllItemsState from "./setAllItemsState";
import updateLoadingItemState from "./updateLoadingItemState";
import {
  ITEM_STATE_LOADING_FAILED,
  ITEM_STATE_PLACEHOLDER
} from "../../constants";
import getShiftedOffset from "./getShiftedOffset";

export default (state, { payload: { offset, limit, offsetId } }) => {
  const shiftedOffset = getShiftedOffset({
    items: state.items,
    offsetId,
    offset
  });
  const upperOffset = offset + limit;

  return {
    ...state,
    items: [
      ...state.items.slice(0, shiftedOffset),
      ...updateLoadingItemState(
        state.items.slice(shiftedOffset, offset),
        ITEM_STATE_PLACEHOLDER
      ),
      ...setAllItemsState(
        state.items.slice(offset, upperOffset),
        ITEM_STATE_LOADING_FAILED
      ),
      ...state.items.slice(upperOffset)
    ]
  };
};
